import {
    PROTECTIONPLAN_ON_CHANGE,
    PROTECTIONPLAN_ON_RESET,
} from '../actionTypes/ProtectionPlanActionTypes';

function ProtectionPlanReducer(state = '', action) {
    switch (action.type) {
        case PROTECTIONPLAN_ON_CHANGE:
            return action.payload;
        case PROTECTIONPLAN_ON_RESET:
            return '';
        default:
            return state;
    }
}
// ProtectionPlanReducer.reducerName = 'selectedProtectionPlan';

export default ProtectionPlanReducer;
